export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Entertainment & Recreation.3905a797.PNG";